import React from 'react';
import '../styles/EkipatNi.css';
function EkipatNi() {
    return (
        <div id="ekipat-ni-container">
            <p id="ekipat-ni">
                    Екипът ни може да се погрижи за всичко - от<span id="arhitekturnoto-planirane"> архитектурното планиране до последните щрихи </span> нужни за Вашия проект.
            </p>
        </div>
    )
}
export default EkipatNi;